import React, { useEffect, useState } from 'react'
import { getFormCheck } from '../services/studentApi';
import { errorToast } from '../utils/errorHandling';
import { AiOutlineLoading } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
// import '../styles/FormProgress.css';

const base_url = process.env.REACT_APP_BASE_URL;

const FormProgress = () => {
    const { t } = useTranslation();
    const [formcheck, setFormcheck] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const participant_id = JSON.parse(localStorage.getItem('participant_id'));
    const lang = localStorage.getItem('i18nextLng');
    const navigate = useNavigate();

    const fetchFormCheck = async () => {
        setIsLoading(true);
        try {
            const formCheckData = await getFormCheck(participant_id);
            if (formCheckData) {
                setFormcheck(formCheckData);
            }
        } catch (error) {
            errorToast(error, t('general.ActionFailed'), t);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchFormCheck();
    }, []);

    return (

        <div className='form-wrapper m-0 pb-1' >
            {isLoading ?
                <div className='d-flex justify-content-center'>
                    <AiOutlineLoading className='spin' />
                </div>
                :
                <>
                    <p className='text-center m-0'>
                        <strong>{t("Form.DisplayedAllForm")}</strong>
                    </p>
                    <div className="form-progress-wrapper">
                        {/* The grid container */}
                        <div className="form-steps-grid">
                            {[
                                {
                                    title: t("Form.PersonalInfoForm"),
                                    link: "/view-personal-info",
                                    filled: formcheck.is_personal_info_filled,
                                    expiry: "2026-02-05"
                                },
                                {
                                    title: t("Form.PassportForm"),
                                    link: "/passport-info",
                                    filled: formcheck.is_passport_filled,
                                    expiry: "2026-02-12"
                                },
                                {
                                    title: t("Form.AccommodationForm"),
                                    link: "/view-accommodation",
                                    filled: formcheck.is_accommodation_filled,
                                    expiry: "2026-02-12"
                                },
                                {
                                    title: t("Form.TransportationForm"),
                                    link: "/view-transportation",
                                    filled: formcheck.is_transportation_filled,
                                    expiry: "2026-02-12"
                                },
                                {
                                    title: t("Form.InterviewForm"),
                                    link: "/view-interview",
                                    filled: formcheck.is_interview_filled,
                                    expiry: "2026-02-05"
                                },
                                {
                                    title: t("Form.InterviewQuestionForm"),
                                    link: "/retreat-interview-question",
                                    filled: formcheck.is_interview_question_filled,
                                    expiry: "2026-02-27"
                                },
                                {
                                    title: t("Form.HealthDeclarationForm"),
                                    link: "/health_declaration",
                                    filled: formcheck.is_health_declaration_filled,
                                    expiry: "2026-03-17"
                                },
                                {
                                    title: t("Form.Experience"),
                                    link: "/view_experience",
                                    filled: formcheck.is_experience_filled,
                                    expiry: null
                                },
                            ].map((item, index) => (
                                <div key={index} className="form-step-card">
                                    <div className="card-content" onClick={() => navigate(`${base_url}${item.link}`)}>
                                        <div className="info-section">
                                            <div className="form-title-link">
                                                {item.title}
                                            </div>
                                            <span className="expiry-tag">
                                                {/* {t("Form.Expiry")}: */}
                                                {!item.expiry ? "" :
                                                    lang === 'en' ?
                                                        dayjs(item.expiry)
                                                            .format(" by D MMM")
                                                        :
                                                        dayjs(item.expiry)
                                                            .locale("zh-cn")
                                                            .format(" YYYY年M月D日前")
                                                }
                                            </span>
                                        </div>
                                        <div className="status-section">
                                            <img
                                                src={`${base_url}/images/${item.filled === "1" ? 'accept.png' : 'cancel.png'}`}
                                                alt="status"
                                                className="status-icon"
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            }

        </div>
    )
}

export default FormProgress